export default "__VITE_ASSET__AmVx6ulE__"